import { apiClient } from './client';

export type MessageChannel = 'EMAIL' | 'SMS';

export interface GuestMessageLogEntry {
  id: string;
  to: string;
  subject: string;
  template: string;
  /** The message that was actually delivered (HTML for email, text for SMS). */
  body: string;
  status: string;
  errorMessage: string | null;
  channel: MessageChannel;
  guestId: string | null;
  eventId: string | null;
  guestName: string | null;
  sentAt: string;
}

export interface GuestMessageLogFilters {
  eventId?: string;
  guestId?: string;
  channel?: MessageChannel[];
  status?: string[];
  template?: string[];
  search?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

export interface GuestMessageLogPage {
  logs: GuestMessageLogEntry[];
  total: number;
  limit: number;
  offset: number;
}

export async function getGuestMessages(
  filters: GuestMessageLogFilters,
): Promise<GuestMessageLogPage> {
  const { data } = await apiClient.get<GuestMessageLogPage>('/guest-messages', {
    params: filters,
  });
  return data;
}

export async function getGuestMessageTemplates(
  eventId: string,
): Promise<{ templates: { template: string; count: number }[] }> {
  const { data } = await apiClient.get<{ templates: { template: string; count: number }[] }>(
    '/guest-messages/filters',
    { params: { eventId } },
  );
  return data;
}
